import { t } from "@impero-com/common/utils/i18n";
import { queryClient } from "@impero-com/common/utils/query_client";
import { emitNotification } from "@impero-com/ui";

import {
    getGetUsersUserIdPushReportsResponsibleQueryKey,
    usePatchUsersUserIdPushReportsResponsible,
} from "api/generated/users/users";

import { invalidateAssignmentCountQuery } from "./useAssignmentCountQuery";

export function useUpdatePushReportResponsibleForUserMutation() {
    return usePatchUsersUserIdPushReportsResponsible({
        mutation: {
            onSuccess: async (_data, { userId }) => {
                emitNotification(
                    "success",
                    t("User_PushReports_PushReports_Updated")
                );
                await Promise.all([
                    queryClient.invalidateQueries({
                        queryKey:
                            getGetUsersUserIdPushReportsResponsibleQueryKey(
                                userId
                            ),
                    }),
                    invalidateAssignmentCountQuery(userId.toString()),
                ]);
            },
        },
    });
}
